import type { FaireProductEntity } from "../../entity_types/product";

export const p_mqdcma86bq: FaireProductEntity = {
  token: "p_mqdcma86bq",
  type: "product",
  name: "Tuberose Musk– HI-FI Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8a450049a1db83f7668f5dc25f3078f35b75769ed25e65864093ff3820bfc238.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7163eaf3d95923d629b792a740400c5deb29316b42e17681fd02bd083a82b08d.jpeg",
    "https://cdn.faire.com/fastly/1800cee1b16136e06841986db86e83ff461a99b2a2da537025a479230571633c.jpeg",
    "https://cdn.faire.com/fastly/ab4ae34282899dba350dedbd2f3d159c92a62d1b3f80390a86f3e8d357f60161.jpeg",
    "https://cdn.faire.com/fastly/401fbceeee82e55c3b57c6d6be6d84875380cc677345e93112d89a0bd690bcc8.jpeg",
  ],
  priceDollars: 9.5,
  description:
    '*RESTOCKING IN SUMMER 2026*\n\n\nEscapes to warmer climates, gardens draped in morning dew, light streaming through sheer curtains.\n\nTuberose Musk is an opulent green floral, for post-clean resets, instant grounding, and escapes to warmer climates. This scent feels both familiar and dreamy, evocative of ornate vases bursting with white florals, gardens draped in morning dew, and light streaming through sheer curtains.\n\nTop notes of fresh cut stems, orange blossom, and ozone are blended with blooming tuberose, jasmine sambac, and ylang ylang, balanced by cashmere wood, sheer sandalwood, and translucent musk.\n\nPRODUCT INFORMATION:\n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.',
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:04:00.543Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
